import React, { useContext } from 'react';
import { FilterContextData } from 'contexts/FilterContext';
import { isGlobalFilterEmpty } from 'parser/filterParser';
import FilterApplyButton from 'components/molecules/Filter/FilterApplyButton';

interface Props {
    isFiltersPane: boolean;
    setAttributeTypeExpandClose: Function;
    onReset: () => void;
    onSaveSelection: () => void;
}

const FOOTER_BUTTON = 'w-[156px] h-8 rounded font-xs flex justify-center items-center cursor-pointer';

function FilterV2Footer({ isFiltersPane, setAttributeTypeExpandClose, onReset, onSaveSelection }: Props) {
    const {
        allCheckedAttribute,
        applyFilterObject,
        applyFilterButtonObject,
        setIdForRestOfComponent,
        setIdForRestOfComponentLoading,
        setIdForRestOfComponentFilterB,
        setFilterBLoading,
        setFilterNullError,
        disablePresetFilter,
    } = useContext(FilterContextData);

    return (
        <div className="bg-white border-t border-filterV2Border px-4 py-4 flex flex-col items-center gap-2">
            {isFiltersPane ? (
                <>
                    <FilterApplyButton
                        containerClassName={`${FOOTER_BUTTON} bg-filterV2Primary`}
                        setIdForRestOfComponent={setIdForRestOfComponent}
                        applyFilterObject={applyFilterObject}
                        applyFilterButtonObject={applyFilterButtonObject}
                        setIdForRestOfComponentLoading={setIdForRestOfComponentLoading}
                        setIdForRestOfComponentFilterB={setIdForRestOfComponentFilterB}
                        setFilterNullError={setFilterNullError}
                        allCheckedAttribute={allCheckedAttribute}
                        setFilterBLoading={setFilterBLoading}
                        setAttributeTypeExpandClose={setAttributeTypeExpandClose}
                    />
                    <div
                        role="button"
                        className={`${FOOTER_BUTTON} border border-filterV2Border text-filterV2TextPrimary`}
                        onClick={() => onReset()}
                    >
                        Reset
                    </div>
                </>
            ) : (
                !disablePresetFilter && (
                    <div
                        role="button"
                        className={`${FOOTER_BUTTON} border border-filterV2Primary text-filterV2Primary ${
                            isGlobalFilterEmpty(allCheckedAttribute) ? 'opacity-50 pointer-events-none' : ''
                        }`}
                        onClick={() => onSaveSelection()}
                    >
                        Save Selection
                    </div>
                )
            )}
        </div>
    );
}

export default FilterV2Footer;
